// Loads the public agency settings once and caches the promise for the tab.

import { parseStorefront, type StorefrontDocument } from '@/lib/storefront/document';
import { parsePublicTheme, type PublicTheme } from '@/lib/storefront/theme-document';

export interface PublicSettings {
  currency: string;
  rateEur: number;
  rateUsd: number;
  name: string;
  shortName: string;
  city: string;
  address: string;
  phone: string;
  whatsapp: string;
  email: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColor: string;
  secondaryColor: string;
  localizedContact: Record<string, unknown>;
  storefront: StorefrontDocument | null;
  theme: PublicTheme | null;
}

const FALLBACK: PublicSettings = {
  currency: 'MAD',
  rateEur: 10.8,
  rateUsd: 10.0,
  name: '',
  shortName: '',
  city: '',
  address: '',
  phone: '',
  whatsapp: '',
  email: '',
  logoUrl: '',
  faviconUrl: '',
  primaryColor: '#FF8A00',
  secondaryColor: '#0d1117',
  localizedContact: {},
  storefront: null,
  theme: null,
};

let cached: Promise<PublicSettings> | null = null;

export function loadPublicSettings(): Promise<PublicSettings> {
  if (!cached) {
    cached = fetch('/api/public-settings', { cache: 'no-store' })
      .then(async (res) => {
        if (!res.ok) return FALLBACK;
        const data = (await res.json()) as Partial<PublicSettings>;
        return {
          ...FALLBACK,
          ...data,
          storefront: parseStorefront(data.storefront),
          theme: parsePublicTheme(data.theme),
        };
      })
      .catch(() => FALLBACK);
  }
  return cached;
}

export function publicAgencyName(settings: PublicSettings): string {
  return settings.shortName || settings.name || 'fleetava';
}

export { FALLBACK as FALLBACK_PUBLIC_SETTINGS };
